import { Injectable } from '@angular/core';
import { Map as MapLibreMap } from 'maplibre-gl';
import { encode as ngeohashEncode } from 'ngeohash';

@Injectable({
    providedIn: 'root',
})
export class MapGeohashService {
    public static geohashNeighborsMatrixSize = 5;

    public centralGeohash?: string;

    private _geohashPrecision: number = 4;

    public get geohashPrecision(): number {
        return this._geohashPrecision;
    }

    public syncGeohashToMap(map: MapLibreMap): void {
        const currentZoom = map.getZoom();
        const mapCenterCoords = map.getCenter();

        if (currentZoom > 8 && this.geohashPrecision !== 4) {
            this._geohashPrecision = 4;
            this.centralGeohash = ngeohashEncode(mapCenterCoords.lat, mapCenterCoords.lng, this.geohashPrecision);
        }

        if (currentZoom <= 8 && this.geohashPrecision !== 3) {
            this._geohashPrecision = 3;
            this.centralGeohash = ngeohashEncode(mapCenterCoords.lat, mapCenterCoords.lng, this.geohashPrecision);
        }
    }

    public updateCentralGeohash(map: MapLibreMap): void {
        const mapCenterCoords = map.getCenter();

        this.centralGeohash = ngeohashEncode(mapCenterCoords.lat, mapCenterCoords.lng, this.geohashPrecision);
    }
}
